var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCafyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162,
    zoomAndPan: "magnify",
    viewBox: "0 0 121.5 121.499994",
    height: 162,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "87efe60abc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 120.796875 0 L 120.796875 120.796875 L 0 120.796875 Z M 0 0 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "15bee7566b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60.398438 0 C 27.042969 0 0 27.042969 0 60.398438 C 0 93.753906 27.042969 120.796875 60.398438 120.796875 C 93.753906 120.796875 120.796875 93.753906 120.796875 60.398438 C 120.796875 27.042969 93.753906 0 60.398438 0 Z M 60.398438 0 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b1161726d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.015625 16.003906 L 107.875 16.003906 L 107.875 110.863281 L 13.015625 110.863281 Z M 13.015625 16.003906 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "166f9c2ef5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.265625 64 L 42 64 L 42 70 L 30.265625 70 Z M 30.265625 64 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "36f4efec6c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79 64 L 90.769531 64 L 90.769531 70 L 79 70 Z M 79 64 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "b6feb94dde"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#87efe60abc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#15bee7566b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffb3a8",
      fillOpacity: 1
    },
    d: "M 0 0 L 120.796875 0 L 120.796875 120.796875 L 0 120.796875 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#2b1161726d)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#de6957",
      fillOpacity: 1
    },
    d: "M 107.769531 31.796875 L 107.769531 63.382812 C 107.769531 64.933594 107.691406 66.480469 107.535156 68.023438 C 107.382812 69.566406 107.152344 71.097656 106.847656 72.621094 C 106.542969 74.140625 106.167969 75.644531 105.714844 77.125 C 105.261719 78.609375 104.742188 80.070312 104.144531 81.5 C 103.550781 82.933594 102.886719 84.332031 102.15625 85.699219 C 101.425781 87.070312 100.625 88.398438 99.765625 89.6875 C 98.902344 90.976562 97.980469 92.21875 96.996094 93.417969 C 96.011719 94.617188 94.96875 95.765625 93.875 96.863281 C 92.777344 97.957031 91.628906 99 90.429688 99.984375 C 89.230469 100.96875 87.988281 101.890625 86.699219 102.753906 C 85.410156 103.613281 84.082031 104.410156 82.714844 105.144531 C 81.347656 105.875 79.945312 106.539062 78.511719 107.132812 C 77.082031 107.726562 75.621094 108.25 74.140625 108.703125 C 72.65625 109.15625 71.152344 109.53125 69.632812 109.835938 C 68.109375 110.140625 66.578125 110.371094 65.035156 110.523438 C 63.492188 110.679688 61.945312 110.757812 60.394531 110.757812 C 34.242188 110.757812 13.015625 89.535156 13.015625 63.382812 L 13.015625 31.796875 C 31.96875 34.957031 38.285156 57.066406 38.285156 57.066406 C 38.285156 25.480469 60.394531 16.003906 60.394531 16.003906 C 60.394531 16.003906 82.503906 25.480469 82.503906 57.066406 C 82.503906 57.066406 88.820312 34.957031 107.769531 31.796875 Z M 107.769531 31.796875 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#323232",
      fillOpacity: 1
    },
    d: "M 66.464844 84.277344 C 63.226562 87.792969 57.710938 87.773438 54.738281 83.910156 C 53.960938 82.90625 52.222656 83.898438 53.007812 84.917969 C 56.726562 89.753906 63.679688 90.25 67.875 85.691406 C 68.746094 84.742188 67.335938 83.328125 66.464844 84.277344 Z M 66.464844 84.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#323232",
      fillOpacity: 1
    },
    d: "M 46.203125 80.675781 C 45.53125 80.40625 44.824219 80.210938 44.105469 80.082031 C 44.457031 79.367188 44.65625 78.574219 44.65625 77.726562 C 44.65625 74.773438 42.257812 72.371094 39.292969 72.371094 C 36.332031 72.371094 33.929688 74.769531 33.929688 77.726562 C 33.929688 79.367188 34.671875 80.835938 35.835938 81.816406 C 35.101562 82.359375 34.4375 83.015625 33.886719 83.792969 C 33.117188 84.886719 34.917969 85.921875 35.679688 84.839844 C 36.277344 83.992188 37.050781 83.359375 37.921875 82.898438 C 39.300781 82.167969 40.929688 81.894531 42.527344 81.988281 C 43.617188 82.054688 44.6875 82.289062 45.652344 82.675781 C 46.894531 83.167969 47.433594 81.160156 46.203125 80.675781 Z M 46.203125 80.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 36.460938 75.199219 C 36.460938 76.230469 37.300781 77.066406 38.328125 77.066406 C 39.359375 77.066406 40.195312 76.230469 40.195312 75.199219 C 40.195312 74.171875 39.359375 73.335938 38.328125 73.335938 C 37.300781 73.335938 36.460938 74.171875 36.460938 75.199219 Z M 36.460938 75.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 36.492188 80.292969 C 37.007812 80.292969 37.425781 79.875 37.425781 79.363281 C 37.425781 78.847656 37.007812 78.429688 36.492188 78.429688 C 35.976562 78.429688 35.558594 78.847656 35.558594 79.363281 C 35.558594 79.875 35.976562 80.292969 36.492188 80.292969 Z M 36.492188 80.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#e4bdbd",
      fillOpacity: 1
    },
    d: "M 41.058594 84.269531 C 43.253906 83.863281 45.1875 84.382812 45.386719 85.433594 C 45.582031 86.484375 43.960938 87.667969 41.769531 88.074219 C 39.578125 88.484375 37.640625 87.960938 37.445312 86.910156 C 37.246094 85.859375 38.867188 84.675781 41.058594 84.269531 Z M 41.058594 84.269531 "
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#166f9c2ef5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#323232",
      fillOpacity: 1
    },
    d: "M 32.460938 68.792969 C 34.035156 66.160156 37.132812 65.5 39.703125 67.136719 C 40.699219 67.769531 41.617188 66.1875 40.625 65.558594 C 37.214844 63.382812 32.945312 64.414062 30.882812 67.871094 C 30.277344 68.882812 31.859375 69.804688 32.460938 68.792969 Z M 32.460938 68.792969 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#323232",
      fillOpacity: 1
    },
    d: "M 74.835938 80.675781 C 75.511719 80.40625 76.214844 80.210938 76.9375 80.082031 C 76.585938 79.367188 76.386719 78.574219 76.386719 77.726562 C 76.386719 74.773438 78.785156 72.371094 81.75 72.371094 C 84.710938 72.371094 87.109375 74.769531 87.109375 77.726562 C 87.109375 79.367188 86.371094 80.835938 85.207031 81.816406 C 85.941406 82.359375 86.605469 83.015625 87.15625 83.792969 C 87.925781 84.886719 86.125 85.921875 85.359375 84.839844 C 84.765625 83.992188 83.992188 83.359375 83.121094 82.898438 C 81.742188 82.167969 80.113281 81.894531 78.515625 81.988281 C 77.425781 82.054688 76.355469 82.289062 75.390625 82.675781 C 74.144531 83.167969 73.605469 81.160156 74.835938 80.675781 Z M 74.835938 80.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 84.578125 75.199219 C 84.578125 76.230469 83.742188 77.066406 82.710938 77.066406 C 81.683594 77.066406 80.847656 76.230469 80.847656 75.199219 C 80.847656 74.171875 81.683594 73.335938 82.710938 73.335938 C 83.742188 73.335938 84.578125 74.171875 84.578125 75.199219 Z M 84.578125 75.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 84.546875 80.292969 C 85.0625 80.292969 85.480469 79.875 85.480469 79.363281 C 85.480469 78.847656 85.0625 78.429688 84.546875 78.429688 C 84.03125 78.429688 83.613281 78.847656 83.613281 79.363281 C 83.613281 79.875 84.03125 80.292969 84.546875 80.292969 Z M 84.546875 80.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#e4bdbd",
      fillOpacity: 1
    },
    d: "M 79.980469 84.269531 C 77.789062 83.863281 75.855469 84.382812 75.65625 85.433594 C 75.460938 86.484375 77.082031 87.667969 79.273438 88.074219 C 81.464844 88.484375 83.402344 87.960938 83.597656 86.910156 C 83.792969 85.859375 82.175781 84.675781 79.980469 84.269531 Z M 79.980469 84.269531 "
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#36f4efec6c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#323232",
      fillOpacity: 1
    },
    d: "M 90.160156 67.871094 C 88.09375 64.414062 83.824219 63.386719 80.417969 65.558594 C 79.429688 66.1875 80.34375 67.769531 81.339844 67.136719 C 83.910156 65.496094 87.011719 66.160156 88.578125 68.792969 C 89.179688 69.800781 90.765625 68.882812 90.160156 67.871094 Z M 90.160156 67.871094 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafyLogo);
export default __webpack_public_path__ + "static/media/cafy_logo.ff6170f1cdf1297d0d121e36cb9889bc.svg";
export { ForwardRef as ReactComponent };